export default __webpack_public_path__ + "static/img/ss-2023.80c0461.jpg";